<form *ngIf="expertFormGroup" [formGroup]="expertFormGroup">
    <p-card class="p-3" header="Datos generales">
        <div class="grid">
            <div class="col input-field">
                <label for="name">Nombre *</label>
                <input pInputText formControlName="name" d-form-field-error />
            </div>
            <div class="col input-field ">
                <label for="legalName">Razón social *</label>
                <input pInputText formControlName="legalName" type="text" d-form-field-error />
            </div>
            <div class="col input-field">
                <label for="vatNumber">CIF *</label>
                <input pInputText formControlName="vatNumber" d-form-field-error />
            </div>
            <div class="col input-field">
                <label for="active" class="mr-1">Activo</label>
                <div class="flex h-full">
                    <p-inputSwitch formControlName="active" d-form-field-error></p-inputSwitch>
                </div>
            </div>
        </div>
        <div class="grid pt-2">
            
            <div class="col input-field ">
                <label for="phone1">Teléfono 1</label>
                <input pInputText formControlName="phone1" type="text" d-form-field-error />
            </div>
            <div class="col input-field ">
                <label for="phone1">Teléfono 2</label>
                <input pInputText formControlName="phone2" type="text" d-form-field-error />
            </div>
            <div class="col input-field ">
                <label for="phone1">Teléfono 3</label>
                <input pInputText formControlName="phone3" type="text" d-form-field-error />
            </div>
            <div class="col input-field ">
                <label for="email">Email</label>
                <input pInputText formControlName="email" type="text" d-form-field-error />
            </div>

        </div>
        <div class="grid pt-2" formGroupName="address">
            <div class="col input-field col-3">
                <label for="name">Dirección *</label>
                <input pInputText formControlName="addressLine1" type="text" d-form-field-error />
            </div>
            <div class="col input-field col-3">
                <label for="name">Código postal</label>
                <input pInputText formControlName="zipCode" type="text" d-form-field-error />
            </div>
            <div class="col input-field col-3">
                <label for="name">Ciudad</label>
                <input pInputText formControlName="city" type="text" d-form-field-error />
            </div>
            <div class="col input-field col-3">
                <label for="name">País</label>
                <p-dropdown [options]="countries" formControlName="countryCode" optionValue="code" [filter]="true"
                    filterBy="name" optionLabel="name" placeholder="Seleccione país" d-form-field-error />
            </div>
        </div>
        <div class="grid pt-2">
            <div class="col input-field col-3">
                <label for="name">Gabinete</label>
                <input pInputText formControlName="cabinet" type="text" d-form-field-error />
            </div>

        </div>
        <div class="mt-4 flex gap-2 justify-content-end">
            <p-button label="Eliminar" *ngIf="allowDelete && expert.id" icon="pi pi-trash" styleClass="p-button-danger"
                (click)="delete()"></p-button>
            <div class="flex-grow-1"></div>
            <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
            <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2"
                (click)="save()"></p-button>
        </div>
    </p-card>
    <p-card header="Acceso a la aplicación" *ngIf="expert.id">
        <div class="grid">
            <div class="col-2 input-field">
                <label for="enableAccess">Activar acceso</label>
                <p-inputSwitch formControlName="enableAccess" (onChange)="onEnableAccessChange()"
                    d-form-field-error></p-inputSwitch>
            </div>
            <div class="col-2 input-field" formGroupName="user" *ngIf="expertFormGroup.value.enableAccess">
                <label for="userName">Nombre de usuario</label>
                <input pInputText id="username" formControlName="userName" type="text" d-form-field-error />
            </div>
            <div class="col-2 input-field" formGroupName="user" *ngIf="expertFormGroup.value.enableAccess">
                <label for="roleId">Perfil</label>
                <p-dropdown id="roleId" [options]="roles" formControlName="roleId" [required]="true" optionValue="id"
                    filterBy="title" optionLabel="title" placeholder="Seleccione perfil" d-form-field-error />
            </div>
            <div class="col-2 input-field"
                *ngIf="expertFormGroup.value.enableAccess && expertFormGroup.value.user!=null && expert.userId==null"
                formGroupName="user">
                <label for="password">Password</label>
                <p-password id="password" type="password" formControlName="password" autocomplete="new-password"
                    [toggleMask]="true" d-form-field-error></p-password>
            </div>
            <div class="col-4 input-field" *ngIf="expert.userId && expertFormGroup.value.enableAccess">
                <label>&nbsp;</label>
                <p-button label="Cambiar contraseña" icon="pi pi-send" styleClass="p-button-secondary"
                    (click)="changePassword()"></p-button>
            </div>
        </div>
    </p-card>
</form>

<p-dialog header="Modificar contraseña" [modal]="true" [(visible)]="visibleChangePass" [style]="{ width: '300px' }">
    <div class="grid">
        <div class="col-12 input-field">
            <label for="password" class="p-col-4">Cambiar contraseña</label>
            <input pPassword type="password" id="password" class="flex-auto" autocomplete="off" [(ngModel)]="password"
                aria-label="Constraseña" />
        </div>
    </div>
    <div class="mt-4 flex gap-2 justify-content-end">
        <p-button label="Cerrar" icon="pi pi-times" styleClass="p-button-secondary"
            (click)="visibleChangePass = false"></p-button>
        <p-button label="Guardar" icon="pi pi-save" (click)="saveChangePassword(password)"></p-button>
    </div>
</p-dialog>
<p-confirmDialog></p-confirmDialog>